import React, { useState } from 'react';
import { ShoppingCartIcon, HeartIcon, MinusIcon, PlusIcon, CheckIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
interface Product {
  id: number;
  name: string;
  price: number;
  image: string;
  category: string;
}
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  const {
    addToCart
  } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [isAdded, setIsAdded] = useState(false);
  const handleAddToCart = () => {
    addToCart(product, quantity);
    setIsAdded(true);
    setTimeout(() => setIsAdded(false), 2000);
  };
  const incrementQuantity = () => setQuantity(prev => prev + 1);
  const decrementQuantity = () => setQuantity(prev => Math.max(1, prev - 1));
  return <div className="group bg-white rounded-lg overflow-hidden border border-gray-200 hover:shadow-xl hover:border-red-200 transition-all duration-300" data-id="element-126">
      {/* Image Container */}
      <div className="relative aspect-square overflow-hidden bg-gray-100" data-id="element-127">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-128" />
        <button className="absolute top-3 right-3 p-2 bg-white rounded-full shadow-md hover:bg-red-50 hover:scale-110 transition-all" data-id="element-129">
          <HeartIcon className="w-5 h-5 text-gray-600 hover:text-red-600" data-id="element-130" />
        </button>
      </div>
      {/* Product Info */}
      <div className="p-4" data-id="element-131">
        <span className="text-xs text-gray-500 uppercase tracking-wide font-medium" data-id="element-132">
          {product.category}
        </span>
        <h3 className="mt-1 text-sm font-medium text-gray-900 line-clamp-2 h-10" data-id="element-133">
          {product.name}
        </h3>
        <div className="mt-3 flex items-center justify-between" data-id="element-134">
          <span className="text-lg font-bold text-gray-900" data-id="element-135">
            ${product.price.toFixed(2)}
          </span>
        </div>
        {/* Quantity Selector */}
        <div className="mt-4 flex items-center gap-2" data-id="element-136">
          <div className="flex items-center border border-gray-300 rounded-md" data-id="element-137">
            <button onClick={decrementQuantity} className="p-2 hover:bg-gray-100 transition" data-id="element-138">
              <MinusIcon className="w-4 h-4" data-id="element-139" />
            </button>
            <span className="px-3 font-medium text-sm" data-id="element-140">{quantity}</span>
            <button onClick={incrementQuantity} className="p-2 hover:bg-gray-100 transition" data-id="element-141">
              <PlusIcon className="w-4 h-4" data-id="element-142" />
            </button>
          </div>
          <button onClick={handleAddToCart} className={`flex-1 flex items-center justify-center gap-2 py-2 px-4 rounded-md font-medium transition-all ${isAdded ? 'bg-green-600 text-white' : 'bg-red-600 text-white hover:bg-red-700 hover:shadow-md'}`} data-id="element-143">
            {isAdded ? <>
                <CheckIcon className="w-4 h-4" data-id="element-144" />
                Added!
              </> : <>
                <ShoppingCartIcon className="w-4 h-4" data-id="element-145" />
                Add
              </>}
          </button>
        </div>
      </div>
    </div>;
}